import {Resolver, useForm} from "react-hook-form";
import "./ContactMe.css";
import { sendNotificationEmail } from '../utils/sendEmail';
type FormValues = {
  name: string;
  email: string;
  message: string;
};

const resolver: Resolver<FormValues> = async (values) => {
  return {
    values: values.name ? values : {},
    errors: !values.name
      ? {
        name: {
          type: 'required',
          message: 'This is required.',
        },
      }
      : {},
  };
};

const ContactMe = () => {

  const {register, handleSubmit, formState: {errors}, reset} = useForm<FormValues>();
  const onSubmit = (data:FormValues) => {
    alert("Thank you for your message");
    //submit data
    sendNotificationEmail(process.env.REACT_APP_MY_EMAIL as string, data.email, data.name, data.message);
    reset();
  }
  console.log(errors);
  return (
    <div className="grad d-flex flex-column"
    style={{
      alignItems: 'center', paddingTop: '30px'
    }}
    >
      <h2>Contact Me</h2>
      <p>I will get back to you within 48 hours!</p>
      <form onSubmit={handleSubmit(onSubmit)} className="custom-form">
        <div className="form-group">
          <label htmlFor="inputName">Your Name</label>
          <input type="text" className="form-control" id="inputName"
                 placeholder="Your Name" {...register("name", {required:true})}/>
        </div>
        <div className="form-group">
          <label htmlFor="inputEmail">Email</label>
          <input type="email" className="form-control" id="inputEmail" placeholder="Email"
                 {...register("email", {required: true, pattern: /^\S+@\S+$/i})}
          />
        </div>
        <div className="form-group">
          <label htmlFor="inputMessage">Message</label>
          <textarea  className="form-control" id="inputMessage" rows={3} placeholder="Message Me"
                     {...register("message", {required: true})}
          />
        </div>
        <div style={{display:'flex ', alignItems:'center', justifyContent:'center'}}>
          <button type="submit" className="btn">Submit</button>
        </div>
      </form>
    </div>
  )
}

export default ContactMe;